// src/hooks/useHover.js
import { useState, useCallback } from 'react';

const useHover = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setTimeout(() => {
      setIsHovered(true);
    }, 100);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setTimeout(() => {
      setIsHovered(false);
    }, 100);
  }, []);

  return {
    isHovered,
    handleMouseEnter,
    handleMouseLeave,
  };
};

export default useHover;